import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'excludeFilter',
  pure: false,
})
export class ExcludeFilterPipe implements PipeTransform {
  transform(items: any[], field: string, value: string): any[] {
    return items ? items.filter((it) => it[field] !== value) : [];
  }
}
